import { render, staticRenderFns } from "./submitstuInfo.vue?vue&type=template&id=59f85684&scoped=true&"
import script from "./submitstuInfo.vue?vue&type=script&lang=js&"
export * from "./submitstuInfo.vue?vue&type=script&lang=js&"
import style0 from "./submitstuInfo.vue?vue&type=style&index=0&id=59f85684&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f85684",
  null
  
)

export default component.exports